var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncementLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57312 1.67173L4.75204 3.50594C4.45796 3.6471 4.14374 3.68246 3.82343 3.6107C3.6138 3.56374 3.50898 3.54026 3.42457 3.53063C2.37644 3.41094 1.72314 4.24048 1.72314 5.19441V5.71791C1.72314 6.67185 2.37644 7.50139 3.42457 7.3817C3.50898 7.37205 3.61381 7.34856 3.82343 7.30163C4.14374 7.22984 4.45796 7.26522 4.75204 7.4064L8.57312 9.24061C9.45023 9.66167 9.88881 9.87218 10.3778 9.70808C10.8668 9.54399 11.0346 9.19185 11.3703 8.48763C12.292 6.55387 12.292 4.35847 11.3703 2.42467C11.0346 1.72045 10.8668 1.36834 10.3778 1.20424C9.88881 1.04014 9.45023 1.25067 8.57312 1.67173Z",
    stroke: "#006838",
    strokeWidth: 0.861538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58104 11.9304L5.72447 12.6363C3.79371 11.105 4.02959 10.3748 4.02959 7.46707H4.68081C4.94509 9.11025 5.56846 9.88857 6.42861 10.452C6.95846 10.799 7.0677 11.5292 6.58104 11.9304Z",
    stroke: "#006838",
    strokeWidth: 0.861538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30772 7.17946V3.73331",
    stroke: "#006838",
    strokeWidth: 0.861538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementLink);
export default __webpack_public_path__ + "static/media/AnnouncementLink.ab43b095dcc1fdfee19ec16fa7dbea8c.svg";
export { ForwardRef as ReactComponent };